import { ComponentStatus } from '../types/component-status.enum';
import { DisplayState } from '../types/display-state.enum';

/**
 * A stale observation is Unknown regardless of what it last said: the backend
 * flags staleness per component (3× its probe interval), and an old "UP" is not
 * evidence of anything. A never-checked component is Unknown too — and so is a
 * missing or unrecognised status: only an explicit DOWN is a confirmed outage.
 *
 * @param status - Status exactly as the wire delivered it; anything the enum does not cover is Unknown.
 * @param isStale - Backend staleness flag for the observation.
 * @param lastCheckedAt - Epoch milliseconds of the last observation; 0 means never checked.
 * @returns The state the row renders.
 */
export function toDisplayState(status: string | undefined, isStale: boolean, lastCheckedAt: number): DisplayState {
  if (isStale || !lastCheckedAt) return DisplayState.Unknown;
  if (status === ComponentStatus.Up) return DisplayState.Available;
  return status === ComponentStatus.Down ? DisplayState.Unavailable : DisplayState.Unknown;
}
